module.exports = __webpack_public_path__ + "static/media/icon-pag-retirada.a440c827.svg";